import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function TrendingTopics() {
  const hotArticles = articles
    .filter((a) => a.isHot)
    .sort((a, b) => b.views - a.views)
    .slice(0, 6);

  const allTags = Array.from(new Set(articles.flatMap((a) => a.tags))).slice(0, 10);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-5">
              <div className="w-1 h-5 rounded-full bg-accent-500"></div>
              <h2 className="font-heading text-lg font-bold text-foreground-900">热搜话题</h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {hotArticles.map((article, index) => (
                <Link
                  key={article.id}
                  to={`/article/${article.slug}`}
                  className="flex items-start gap-3 p-4 rounded-xl bg-background-100 hover:bg-accent-50 transition-colors cursor-pointer group"
                >
                  <span className={`flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-full text-xs font-bold ${
                    index < 3 ? 'bg-accent-500 text-white' : 'bg-background-200 text-foreground-600'
                  }`}>
                    {index + 1}
                  </span>
                  <div className="min-w-0">
                    <h3 className="text-sm font-medium text-foreground-900 group-hover:text-accent-600 transition-colors line-clamp-2 leading-snug">{article.title}</h3>
                    <span className="text-xs text-foreground-500 mt-1 block">{article.views.toLocaleString()} 热度</span>
                  </div>
                </Link>
              ))}
            </div>
          </div>

          <div>
            <div className="flex items-center gap-2 mb-5">
              <div className="w-1 h-5 rounded-full bg-secondary-500"></div>
              <h2 className="font-heading text-lg font-bold text-foreground-900">热门标签</h2>
            </div>
            <div className="bg-background-100 rounded-xl p-5">
              <div className="flex flex-wrap gap-2">
                {allTags.map((tag) => (
                  <span
                    key={tag}
                    className="px-3 py-1.5 rounded-full text-xs font-medium bg-background-200 text-foreground-700 hover:bg-secondary-100 hover:text-secondary-900 transition-colors cursor-pointer"
                  >
                    #{tag}
                  </span>
                ))}
              </div>
            </div>

            <div className="mt-6 bg-gradient-to-br from-primary-500 to-primary-700 rounded-xl p-6 text-white">
              <h3 className="font-heading font-bold text-lg mb-2">🔥 吃瓜爆料投稿</h3>
              <p className="text-sm text-white/80 leading-relaxed mb-4">你有娱乐圈一手瓜料？欢迎投稿爆料，一经采用即付丰厚稿酬！</p>
              <a
                href="mailto:tips@17chigua.com"
                className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg bg-white/20 hover:bg-white/30 text-white text-sm font-medium transition-colors cursor-pointer"
              >
                <i className="ri-mail-send-line"></i> 立即投稿
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}